"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UserInfoType = exports.UserContactType = exports.LinkType = exports.ConfigurationType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _secutixObjects = require("@gravity/secutix-objects");
function cov_2rg2aieoh9() {
  var path = "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/config/lib/type.js";
  var hash = "3aaeaaf4afb735cb3393140c47af3cb71c1acc5d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/config/lib/type.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 24
        },
        end: {
          line: 9,
          column: 2
        }
      },
      "1": {
        start: {
          line: 11,
          column: 31
        },
        end: {
          line: 18,
          column: 2
        }
      },
      "2": {
        start: {
          line: 20,
          column: 28
        },
        end: {
          line: 27,
          column: 2
        }
      },
      "3": {
        start: {
          line: 29,
          column: 33
        },
        end: {
          line: 86,
          column: 2
        }
      },
      "4": {
        start: {
          line: 96,
          column: 19
        },
        end: {
          line: 140,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3aaeaaf4afb735cb3393140c47af3cb71c1acc5d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2rg2aieoh9 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2rg2aieoh9();
var LinkType = exports.LinkType = (cov_2rg2aieoh9().s[0]++, _propTypes.default.shape({
  rank: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  style: _propTypes.default.string,
  name: _propTypes.default.string,
  url: _propTypes.default.string
}));
var UserContactType = exports.UserContactType = (cov_2rg2aieoh9().s[1]++, _propTypes.default.shape({
  firstName: _propTypes.default.string.isRequired,
  lastName: _propTypes.default.string.isRequired,
  structureName: _propTypes.default.string,
  onClick: _propTypes.default.func.isRequired,
  email: _propTypes.default.string.isRequired,
  contactToShow: _propTypes.default.string
}));
var UserInfoType = exports.UserInfoType = (cov_2rg2aieoh9().s[2]++, _propTypes.default.shape({
  firstName: _propTypes.default.string,
  lastName: _propTypes.default.string,
  email: _propTypes.default.string,
  title: _propTypes.default.string,
  preferredLanguage: _propTypes.default.string,
  structureName: _propTypes.default.string
}));
var ConfigurationType = exports.ConfigurationType = (cov_2rg2aieoh9().s[3]++, _propTypes.default.shape({
  baseUrl: _propTypes.default.string,
  restApiUrl: _propTypes.default.string,
  publicPath: _propTypes.default.string,
  institutionCode: _propTypes.default.string,
  organizationCode: _propTypes.default.string,
  salesChannelCode: _propTypes.default.string,
  pointOfSalesCode: _propTypes.default.string,
  timeZoneOffset: _propTypes.default.number,
  privacyStatementURL: _propTypes.default.string,
  generalConditionsURL: _propTypes.default.string,
  privacyPolicyURL: _propTypes.default.string,
  terminateSubscriptionURL: _propTypes.default.string,
  helpURL: _propTypes.default.string,
  contactURL: _propTypes.default.string,
  contactEmail: _propTypes.default.string,
  accountURL: _propTypes.default.string,
  continueShoppingURL: _propTypes.default.string,
  address: _secutixObjects.AddressType,
  pointOfSalesType: _propTypes.default.string,
  isPointOfSalesRunning: _propTypes.default.bool,
  currentLanguage: _propTypes.default.string,
  institutionLanguage: _propTypes.default.string,
  languages: _propTypes.default.arrayOf(_propTypes.default.string),
  paymentTypes: _propTypes.default.arrayOf(_propTypes.default.string),
  creditCardPaymentMethodId: _propTypes.default.number,
  currencyCode: _propTypes.default.string,
  googleAnalyticsId: _propTypes.default.number,
  googleAnalyticsDomain: _propTypes.default.number,
  googleTagManagerContainerId: _propTypes.default.string,
  recaptchaSiteKey: _propTypes.default.string,
  hasActivePartnerAdvantages: _propTypes.default.bool,
  // Tells if the pages are embedded in the mobile app
  isEmbedded: _propTypes.default.bool,
  seasonHighlighted: _propTypes.default.bool,
  customLinks: _propTypes.default.arrayOf(_secutixObjects.NavigationLinkType),
  hardware: _propTypes.default.arrayOf(_secutixObjects.HardwareType),
  pspParameters: _propTypes.default.objectOf(_propTypes.default.string),
  physicalDeskId: _propTypes.default.number,
  virtualOperator: _propTypes.default.string,
  pointOfSalesId: _propTypes.default.number,
  paymentMethodId: _propTypes.default.number,
  shipmentModeId: _propTypes.default.number,
  pspAccessMethod: _propTypes.default.oneOf(['EFT_POS', 'MOTO', 'MIXED', 'WEB_POST', 'WEB_REDIRECT']),
  openingTime: _propTypes.default.string,
  closingTime: _propTypes.default.string,
  printingTcpPort: _propTypes.default.number
}));

/**
 * This object represent the basic information we need to provide to any component and nucleo
 * to load data, do action and display (langauge, hostname, currency, etc ...)
 *
 * There are basic information that are copy pasted from the result of a call and computed or normalized
 * data for common use
 */

var ConfigType = (cov_2rg2aieoh9().s[4]++, _propTypes.default.shape({
  /**
   * Initiliation data, they are provided to the widget
   */
  // Parameter value pass to the widget. It contains the key to access the rest api
  apiKey: _propTypes.default.string,
  // Parameter value pass to the widget. It contains the link to the point of sales of reference
  hostname: _propTypes.default.string,
  /**
   * Loaded data, plain object received from the server, should be removed when all data are correctly processed
   */
  // all the parameters of the configuraiton
  configuration: ConfigurationType,
  // All the translations that were change in the configuration
  labelOverrides: _propTypes.default.object,
  // the style override defined by the customer
  style: _propTypes.default.shape({
    properties: _propTypes.default.object
  }),
  // If there is a pending session that can be reused.
  session: _propTypes.default.shape({
    csrfToken: _propTypes.default.string,
    sessionToken: _propTypes.default.string
  }),
  /**
   * Processed data, from the data loaded, we define the common data used by all the systems
   * Some of this data may be updated by an action later, like language if the user change the language.
   */
  // contains the language that should be displayed to the user. See the rules in the model
  language: _propTypes.default.string,
  // Contains the language of the institution, all translatsions should be provided in this language,
  // it is the fallback value if a translation does not exist in the chosen language
  defaultLanguage: _propTypes.default.string,
  // Contains the currency that will be used for prices and paiement
  currencyCode: _propTypes.default.string,
  // the header that should be sent to all REST api call
  headers: _propTypes.default.shape({
    'Content-Type': _propTypes.default.string,
    'X-Secutix-Host': _propTypes.default.string,
    'X-API-Key': _propTypes.default.string,
    'X-CSRF-Token': _propTypes.default.string
  })
}));
var _default = exports.default = ConfigType;